import moment from "moment";
import { ValueFormatterParams } from "ag-grid-community";

export const dateNumberValueFormatter = (params: ValueFormatterParams) => {
    const { value, colDef } = params;
    const maskFormat = colDef.cellEditorParams.maskFormat || "MM/DD/YYYY";

    if (!value) {
        return "";
    }

    const momentDate = moment.unix(value);
    if (momentDate.isValid()) {
        return momentDate.utc().format(maskFormat);
    }

    return "";
};
